import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Form } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import ReactGa from 'react-ga';

import { API, EMAIL_DOMAIN_PATTERN, EMAIL_USERNAME_PATTERN, prices, routes } from '../../config';
import images from '../../utils/images';


// Limited Prize ID's There can Be only 1 Grand Prize and 4 Limited Prizes. Crosschecked with the API
const GP = 12;

const LP1 = 1;
const LP2 = 2;
const LP3 = 3;
const LP4 = 4;
const LP6 = 6;
const LP7 = 7;
const LP8 = 8;
const LP10 = 10;
const LP11 = 11;

// Duplicated Prize ID's Valid only if there are any available. If not Ignore
const CH1 = 3;
const CH2 = 5;
const BU1 = 9;
const BU2 = 11;

const HomePage = ({history}) => {
  const [userID, setUserID] = useState(null);
  const [name, setName] = useState('');
  const [mobile, setMobile] = useState('');
  const [month, setMonth] = useState('01');
  const [year, setYear] = useState('2002');
  const [outlet, setOutlet] = useState('Chimichanga VivoCity');
  const [email, setEmail] = useState('');
  const [terms, setTerms] = useState('');
  
  const [nameErr, setNameErr] = useState('');
  const [mobileErr, setMobileErr] = useState('');
  const [dobErr, setDobErr] = useState('');
  const [outletErr, setOutletErr] = useState('');
  const [emailErr, setEmailErr] = useState('');
  const [termsErr, setTermsErr] = useState('');
  const [emptyErr, setEmptyErr] = useState('');

  const [degrees, setDegrees] = useState(0);

  const [userVerified, setUserVerified] = useState(false);
  const [spinActivated, setSpinActivated] = useState(false);
  const [userErr, setUserErr] = useState(false);

  const [gpAllowed, setGPAllowed] = useState(false);
  const [limitedPrize1Allowed, setLimitedPrize1Allowed] = useState(false);
  const [limitedPrize2Allowed, setLimitedPrize2Allowed] = useState(false);
  const [limitedPrize3Allowed, setLimitedPrize3Allowed] = useState(false);
  const [limitedPrize4Allowed, setLimitedPrize4Allowed] = useState(false);
  const [limitedPrize6Allowed, setLimitedPrize6Allowed] = useState(false);
  const [limitedPrize7Allowed, setLimitedPrize7Allowed] = useState(false);
  const [limitedPrize8Allowed, setLimitedPrize8Allowed] = useState(false);
  const [limitedPrize10Allowed, setLimitedPrize10Allowed] = useState(false);
  const [limitedPrize11Allowed, setLimitedPrize11Allowed] = useState(false);

  const onChange = (input, setter, validator, item, setErr) => {
    setEmptyErr(false);
    setUserErr(false);
    setter(input);
    if (validator) {
      validator(input, item, setErr);
    }
  };

  const onMobileChange = (input) => {
    if ((!input || !/\D/.test(input)) && input.trim().length <= 10) {
      setUserErr(false);
      setMobile(input);
      validateMobile(input);
    }
  }

  const validateEmpty = (input, item, setErr) => {
    if (!input || input.trim() === '') {
      setErr(` `);
      return false;
    }
    setErr('');
    return true;
  };

  const validateEmail = (input) => {
    if (!input.trim()) {
      setEmailErr(' ');
      return false;
    }
    if (input.indexOf('@') >= 0) {
      const emailParts = input.split('@');
      if (!emailParts[0].match(EMAIL_USERNAME_PATTERN) || !emailParts[1].match(EMAIL_DOMAIN_PATTERN)) {
        setEmailErr('Email is invalid');
        return false;
      }
    } else {
      setEmailErr('Email is invalid');
      return false;
    }
    setEmailErr('');
    return true;
  };

  const validateMobile = (input) => {
    if (!input.trim()) {
      setMobileErr(' ');
      return false;
    }

    // VALIDATE SINGAPORE NUMBER..
    if (input.trim().length < 8) {
      setMobileErr('Phone number is invalid');
      return false;
    }
    
    if ( input.charAt(0) !== '6' && input.charAt(0) !== '8' && input.charAt(0) !== '9' ) {
      setMobileErr('Phone number is invalid');
      return false;
    }

    setMobileErr('');
    return true;
  };

  const onTermsChange = (checked) => {
    setTerms(checked);
    setTermsErr(false);
  };

  const onSubmit = async () => {
    const dob = `${year}-${month}-01`;

    validateEmpty(name, 'Name', setNameErr);
    validateEmpty(dob, 'Date of Birth', setDobErr);
    validateEmpty(outlet, 'Outlet Participated', setOutletErr);
    const isEmail = validateEmail(email);
    const isMobile = validateMobile(mobile);
	
	ReactGa.event({
		category: 'Submit Button',
		action: 'Clicked'
	});

    if (!name || !dob || !email || !mobile || !outlet ) {
      setEmptyErr(true);
      return;
    }

    if (dob) {
      const today = new Date();
      const birthDate = new Date(dob);
      const age = today.getFullYear() - birthDate.getFullYear();
      const months = today.getMonth() - birthDate.getMonth();
      const days = today.getDate() - birthDate.getDate();

      if (age < 18) {
        setDobErr('You should be 18+ to continue');
        return;
      }

      if (age === 18) {
        if (months < 0 || (months === 0 && days < 0)) {
          setDobErr('You should be 18+ to continue');
          return;
        }
      }
    }

    if (!terms) {
      setTermsErr('Please agree to the terms and conditions');
      return;
    }

    if (name && dob && isEmail && isMobile) {
      try {
		
		const data = {
          email,
          mobile,
          dob,
		      outlet,
          name
        };
        const response = await axios({
          method: 'POST',
          url: API.registerUser,
          data
        });
		
        if (response.data.success) {
          setUserVerified(true);
          setUserID(response.data.data.id);
          scrollSpinnerToView();	

			ReactGa.event({
				category: 'User',
				action: 'New User Created',
				label: 'User Id: ' + response.data.data.id
			});
			
        } else {
          setUserErr(true);
        }
		
		
      } catch (err) {
        if (err.response && err.response.data && err.response.data.error) {
          if (err.response.data.error.toLowerCase().indexOf('email') >= 0) {
            setEmailErr(' ');
          }
          if (err.response.data.error.toLowerCase().indexOf('phone') >= 0) {
            setMobileErr(' ');
          }
        }
        setUserErr(true);
      }
    } else {
      setEmptyErr('All fields are mandatory');
    }
  };

  useEffect(() => {
    const getAllowedDraws = async () => {
      try {
        const response = await axios({
          method: 'GET',
          url: API.registerDraw
        });
        if (response.data.success) {
          setGPAllowed(response.data.data.gp);
          setLimitedPrize1Allowed(response.data.data.limitedPrize1);
          setLimitedPrize2Allowed(response.data.data.limitedPrize2);
          setLimitedPrize3Allowed(response.data.data.limitedPrize3);
          setLimitedPrize4Allowed(response.data.data.limitedPrize4);
          setLimitedPrize6Allowed(response.data.data.limitedPrize6);
          setLimitedPrize7Allowed(response.data.data.limitedPrize7);
          setLimitedPrize8Allowed(response.data.data.limitedPrize8);
          setLimitedPrize10Allowed(response.data.data.limitedPrize10);
          setLimitedPrize11Allowed(response.data.data.limitedPrize11);
        } else {
          setGPAllowed(false);
          setLimitedPrize1Allowed(false);
          setLimitedPrize2Allowed(false);
          setLimitedPrize3Allowed(false);
          setLimitedPrize4Allowed(false);
          setLimitedPrize6Allowed(false);
          setLimitedPrize7Allowed(false);
          setLimitedPrize8Allowed(false);
          setLimitedPrize10Allowed(false);
          setLimitedPrize11Allowed(false);
        }
      } catch (err) {
        setGPAllowed(false);
        setLimitedPrize1Allowed(false);
        setLimitedPrize2Allowed(false);
        setLimitedPrize3Allowed(false);
        setLimitedPrize4Allowed(false);
        setLimitedPrize6Allowed(false);
        setLimitedPrize7Allowed(false);
        setLimitedPrize8Allowed(false);
        setLimitedPrize10Allowed(false);
        setLimitedPrize11Allowed(false);
      }
    };

    getAllowedDraws();
	
	ReactGa.initialize('UA-180777105-1')
	// Report the page view name
	ReactGa.pageview(window.location.pathname + window.location.search)
	
  }, []);

  const spinTheWheel = async () => {
	
	ReactGa.event({
		category: 'Spin Button',
		action: 'Clicked',
		label: 'User Id: ' + userID
	});
	
    setSpinActivated(true);

		var x = 720;
		var y = 1800;

    var deg = degrees + Math.floor(Math.random() * (y)) + x;

    // Select price
    let remainder = (deg - 12) % 360;
    if (remainder % 30 <= 3) {
      deg = deg + 5;
      remainder = (deg - 12) % 360;
    }

    let price = Math.ceil(remainder / 30);
    // console.log('PRIZE ==>', price, prices[price]);

    if (price === GP && !gpAllowed) {
      deg = deg + 150;
      price = 5;
    }
    if (price === LP1 && !limitedPrize1Allowed) {
      deg = deg + 120;
      price = price + 4;
    }
    if (price === LP2 && !limitedPrize2Allowed) {
      deg = deg + 90;
      price = price + 3;
    }
    if (price === LP3 && !limitedPrize3Allowed) {
      deg = deg + 60;
      price = price + 2;
    }  
    if (price === LP4 && !limitedPrize4Allowed) {
      deg = deg + 30;
      price = price + 1;
    }
    if (price === LP6 && !limitedPrize6Allowed) {
      deg = deg + 90;
      price = price + 3;
    }  
    if (price === LP7 && !limitedPrize7Allowed) {
      deg = deg + 60;
      price = price + 2;
    }
    if (price === LP8 && !limitedPrize8Allowed) {
      deg = deg + 30;
      price = price + 1;
    }
    if (price === LP10 && !limitedPrize10Allowed) {
      deg = deg - 30;
      price = price - 1;
    }
    if (price === LP11 && !limitedPrize11Allowed) {
      deg = deg - 60;
      price = price - 2;
    }

    // Enable code if Prizes Repeat more than once
     /* const randomness = Math.random() > 0.7;
    if (price === BU1 && randomness) {
      deg = deg - 60;
      price = 2;
    }
    if (price === CH1 && randomness) {
      deg = deg - 60;
      price = 3;
    }
    if (price === BU2 && randomness) {
      deg = deg - 90;
      price = 9;
    }
    if (price === CH2 && randomness) {
      deg = deg - 90;
      price = 8;
    }*/
    // console.log('Adjusted pricePRIZE ==>', price, prices[price]);
    
    document.getElementById('spinwheel-box').style.transform = "rotate(" + deg + "deg)";

    setDegrees(deg);
    setTimeout(async () => {
      // Send Result to API
      try {
		  
        const response = await axios({
          method: 'POST',
          url: API.registerDraw,
          data: {
            user_id: userID,
            price
          }
        });
        if (response.data.success) {
          history.push(routes.thankyou, {email: email, name: name, price: prices[price]});
		  
			ReactGa.event({
				category:'Draw',
				action: 'Prize Won',
				label: 'User Id: ' + userID + ' won Price Id: ' + response.data.data.price 
			})
		  
        }
		
      } catch (err) {
        console.log(err);
      }
    }, 7500);
  }

  const scrollSpinnerToView = (event) => {
    if (event) {
      event.preventDefault();
    }
    document.getElementById('spinner-comp').scrollIntoView({
      behavior: 'smooth',
      block: 'end'
    });
  };

  const outletsList = [{ "id" : 1, "name": "Chimichanga Little India"},{ "id" : 2, "name": "Chimichanga Holland Village"},{ "id" : 3, "name": "Chimi's Marina Bay"},{ "id" : 4, "name": "Chimi's Somerset"}];

  const renderYears = () => {
    const optionsList = [];
    for (let i=2004; i>=1904; i--) {
      optionsList.push(<option key={i} value={i}>{i}</option>);
    }
    return optionsList;
  };
	const months = 	[{ "id" : 1, "name": "Jan"}, { "id" : 2,"name": "Feb"}, { "id" :  3,"name": "Mar"}, { "id" : 4,"name": "Apr"}, { "id" : 5,"name": "May"}, { "id" : 6,"name": "Jun"}, { "id" : 7,"name": "Jul"}, { "id" : 8,"name": "Aug"}, { "id" : 9,"name": "Sep"}, { "id" : 10,"name": "Oct"}, { "id" : 11,"name": "Nov"}, { "id" : 12,"name": "Dec"} ]
  return (
    <div className="page-wrapper">
      <div className="page-root">
        <header style={{ paddingTop:"0px", display:"block"}} >
          <div className="container">
            <div className="row">
              <div className="col-md-12 d-none">
                <h1 className="text-center orangeText">Congratulations!</h1>
                <h2 className="text-center orangeText mb-4">
                  You’ve spotted Chimichanga’s<br/>
                  infamous neon donkey!
                </h2>
              </div>	
              <div>
                <img src={images.heroBanner2021} className="img-fluid" alt="CHIMICHNAGA" />
              </div>
              <h3 className="col-md-12 d-none text-center blueText hashtag-heading">
                #TheNeonDonkeySaysHi
              </h3>
            </div>		
          </div>
        </header>
        <main>
        <section className="user-thankyou-section" style={{display:'block'}} >
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-md-10 mb-2 text-center">                  
                  <div className="thankyou-message  mb-4 my-md-5">
                    <h2 className="text-center">Oops! You just missed it this time...</h2>
                    <h1 className="text-center pricePreText">But Stay in tuned with us</h1>
                    <h1 className="text-center priceText">We'll BE Right Back!</h1>
                    <h2 className="mb-4">
                      CHECK OUT OUR SOCIAL CHANNELS
                    </h2>
                    <h4 style={{textTransform: 'none',}}>Be ready to Spin the Wheel next time!</h4>
                  </div>
                  
                </div>
                <div className="col-8 d-none col-md-5">
                  <img src={images.logo} className="img-fluid logo" alt="CHIMICHNAGA" />
                </div>
              </div>
            </div>
          </section>
          <section className="user-landing-section" style={{display:'none'}} >
            <div className="container">
              <div className="row">
                <div className="col-md-12 my-5">
                  <h1 className="text-center mb-4">please fill in details to participate</h1>
                  <div className="registration-form">
                    <form >
                      <div className="row justify-content-center">
                        <div className="form-group col-md-12">
                          <label htmlFor="name">Name</label>
                          <input
                            type="text"
                            className={`form-control ${nameErr && 'error'}`}
                            placeholder="Your Name"
                            id="name"
                            value={name}
                            onChange={(e) => onChange(e.target.value, setName, validateEmpty, 'Name', setNameErr)}
                          />
                        </div>
					</div>	
					<div className="row justify-content-center">	
                        <div className="form-group col-md-6">
                          <label htmlFor="phone">Phone Number</label>
                          <div className="input-group">
                          <div className="input-group-prepend">
                            <div className="input-group-text">+65</div>
                          </div>
                          <input
                            type="text"
                            maxLength="8"
                            className={`form-control ${mobileErr && 'error'}`}
                            placeholder="XXXXXXXX"
                            id="phone"
                            value={mobile}
                            onChange={(e) => onMobileChange(e.target.value)}
                            />
                          </div>
                          <Form.Text className="text-muted text-error">
                            {mobileErr}
                          </Form.Text>
                        </div>
                        <div className="form-group col-md-6">
							<label htmlFor="dob">Date of Birth <span style={{ fontSize : "1rem"}}>(Month / Year)</span></label>
							<div className="row">
							  
							  {/* <input
								type="date"
								className={`form-control ${(dobErr || emptyErr) && 'error'}`}
								min="1900-01-01"
								max="2002-12-31"
								placeholder="mm/yyyy"
								id="dob"
								value={dob}
								onChange={(e) => onChange(e.target.value, setDob, validateEmpty, 'Date of Birth', setDobErr)}
							  /> */}
							  <div className="col-6">
							  <select
								className={`form-control ${dobErr && 'error'}`}
								onChange={(e) => onChange(e.target.value, setMonth, validateEmpty, 'Date of Birth', setDobErr)}
							  >
								{	
									months.map((item, i) => { return <option key={i} value={item.id} >{item.name}</option> })
								}
							  </select>
							  </div>
							  <div className="col-6 pl-0">
							  <select
								className={`form-control ${dobErr && 'error'}`}
								onChange={(e) => onChange(e.target.value, setYear, validateEmpty, 'Date of Birth', setDobErr)}
							  >
								{
								  renderYears()
								}
							  </select>
							  </div>
						  </div>
                          <Form.Text className="text-muted text-error">
                            {dobErr}
                          </Form.Text>
                        </div>
						
					</div>	
					<div className="row justify-content-center">	
          <div className="form-group col-md-12">
                          <label htmlFor="email">Email</label>
                          <input
                            type="email"
                            className={`form-control ${emailErr  && 'error'}`}
                            placeholder="yourname@domain.com"
                            id="email"
                            value={email}
                            onChange={(e) => onChange(e.target.value, setEmail, validateEmail)}
                          />
                          <Form.Text className="text-muted text-error">
                            {emailErr}
                          </Form.Text>
                        </div>	
                        
                        
						<div className="form-group col-md-6 d-none">
                          <label htmlFor="outlet">Outlet Participated At</label>
                          <select
                            className={`form-control ${outletErr && 'error'}`}
								onChange={(e) => onChange(e.target.value, setOutlet, validateEmpty, 'Outlet Participated', setOutletErr)}
                           >
                             <option value="">Please Select</option>
                            {	
                              outletsList.map((item, i) => { return <option key={i} value={item.name} >{item.name}</option> })
                            }
							
						            </select>                          
                        </div>
					</div>	
					<div className="row justify-content-center">		
                        <div className="form-group form-check col-md-12 text-center mt-4">
                          <label className="agree-terms">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={terms}
                              onChange={(e) => onTermsChange(e.target.checked)}
                            />
                              I agree to the terms & conditions and DECLARE THAT I AM OF LEGAL DRINKING AGE
                          </label>
                          <Form.Text className="text-muted text-error">
                            {termsErr}
                          </Form.Text>
                        </div>
                        <Form.Text className="text-muted pb-3 text-error">
                          {emptyErr && 'All fields are mandatory'}
                        </Form.Text>
                        <Form.Text className="text-muted pb-3 text-error">
                          {userErr && 'Oops limited to one spin per registered mobile number and/or email'}
                        </Form.Text>
                        {
                          !userVerified
                            && <div className="form-group form-check col-md-12">
                            <button className="app-button" onClick={onSubmit}>Submit</button>
                          </div>
                        }
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 mb-5" id="spinner-comp">
                  <div id="mainbox" className="spinwheel-mainbox">
                    <div className="spin-wheel-center">
                      <img src={images.spinWheelCenter} className="img-fluid" alt="" />
                    </div>
                    <div id="spinwheel-box" className="spinwheel-box">
                      <div className="box1">
                        <span className="portion1"><b>1 TIX TO COFFEE WORKSHOP</b></span>
                        <span className="portion2"><b>1 SET TOPO CHICO HARD SELTZER</b></span>
                        <span className="portion3"><b>1 TIX TO COCKTAIL TRAIL</b></span>
                        <span className="portion4"><b>5 SHOTS OF TEQUILA</b></span>
                        <span className="portion5"><b>1 GLASS HOUSEPOUR DRINK</b></span>
                        <span className="portion6"><b>ONE LOADED NACHOS</b></span>
                      </div>
                      <div className="box2">
                        <span className="portion1"><b>TRIO OF TACOS</b></span>
                        <span className="portion2"><b>1 PINT HAPPY DONKEY IPA</b></span>
                        <span className="portion3"><b>$500 TRAVEL VOUCHER</b></span>
                        <span className="portion4"><b>1 PINT BURRO NEGRO OATMEAL STOUT</b></span>
                        <span className="portion5"><b>1 BTL RON CAYO GRANDE CLUB</b></span>
                        <span className="portion6"><b>ONE QUESADILLA</b></span>
                      </div>
                    </div>
                    <div className="spin-wheel-pointer">
                      <img src={images.spinWheelSelectedCenter} alt="" className="img-fluid" />
                    </div>
                  </div>
                  <div className="spin-wheel-container">
                    <div className="spin-button-holder" style={{textAlign: 'center'}}>
                      {!userVerified && <span className="overlay-error">Please fill all the details above to participate.</span>}
                      <button
                        className="spin"
                        onClick={(userVerified && !spinActivated) ? spinTheWheel : () => () => {}}
                        disabled={!(userVerified && !spinActivated)}
                      >
                        <span>Click to Spin</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <footer>
            <section>
              <div className="container">
                <div className="row">
                  <div className="col-md-12 text-center mb-2">
                    <h5>Terms & conditions</h5>
                  </div>
                  <div className="col-md-12 text-center">        
                    <b>1.</b> “Spin & Win” game is organised by Chimichanga VivoCity (Chimis City Pte Ltd) and is open to participants who have registered. Do note you need to be a minimum age of 18 to participate. 
                    <b>2.</b>  Limited to one spin per registered mobile number and email address. 
                    <b>3.</b>  Rewards cannot be exchanged or redeemed for cash. 
                    <b>4.</b>  Chimichanga VivoCity (Chimis City Pte Ltd) reserves the right to change these terms and conditions, including the right to cancel the “Spin & Win” in such manner as they deem fit, without prior notice or reason, and without liability to such participant or winner. 
                    <b>5.</b>  Chimichanga VivoCity (Chimis City Pte Ltd) will notify participant's prize redemption through the email address indicated on the registration page submitted by the prize winner of the "Spin & Win” wheel. Do note your entry will be voided if you have input a wrong email address. 
                    <b>6.</b>  Chimichanga VivoCity (Chimis City Pte Ltd) may use all contact information provided by each Participant to conduct verification and other actions in connection with the Contest (including but not limited to those actions stated in these Contest Rules). In addition to the above-mentioned,
                     Chimichanga VivoCity (Chimis City Pte Ltd) may also use the contact details for any promotional, advertising (included targeted advertising) or marketing activities which Chimichanga VivoCity (Chimis City Pte Ltd) believes may be of interest to the Participant. This includes sending out marketing,
                      advertising (including targeted advertising), communication and promotional materials to the Participants relating to any products, marketed or sold by its various Chimichanga or Chimi’s outlets. If a Participant wishes to withdraw consent to any specific use of his/her contact details, he/she should email marketing@chimichanga.sg
                            
                  </div>
                </div>
              </div>	
            </section>
          </footer>
        </main>
      </div>
    </div>
  );
};

export default withRouter(HomePage);
